import OrganizationWebhookSelector from "../../components/WebhookConfig/Webhookconfig";


import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import "../../components/CommunicationTemplete/CommunicationTemplate.css";


const defaultTheme = createTheme();

const WebhookConfig = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Webhook Configuration</h1>
          <p>Configure webhooks to receive real-time updates.</p>
        </div>
      </div>

      <OrganizationWebhookSelector />
    </ThemeProvider>
  );
};

export default WebhookConfig;